<template>
  <div>
    <div
      :class="{photo_tip_color:1,banner:1,wait:!is_finished,ing:is_finished,global_wait:!is_finished&&isGlobal,completed:page_type==='success'}"
    >
      <p />
    </div>
    <div class="split"></div>
  </div>
</template>
<script>
export default {
  props: ["formItem", "idx", "is_finished", "page_type"],
  computed: {
    isGlobal() {
      let up = new URLSearchParams(location.search);
      return up.get("location_country") !== "BR";
    }
  }
};
</script>
<style lang="scss" scoped>
.banner {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 2.08rem;
  p {
    position: relative;
    z-index: 10;
    width: 1.6rem;
    height: 1.6rem;
    background-size: 100% !important;
    transform: translateY(0.4rem);
  }
  &.wait {
    background-color: #2697ff;
    p {
      background: url("../../images/audit-wait@2x.png") no-repeat;
    }
  }
  &.ing {
    background-color: #91a0b4;
    p {
      background: url("../../images/audit-ing@2x.png") no-repeat;
    }
  }
  &.global_wait {
    background-color: #ff7226;
    p {
      background: url("../../images/audit_global_wait@2x.png") no-repeat;
    }
  }
  &.completed {
    background-color: #18c47c;
    p {
      background: url("../../images/audit-success@2x.png") no-repeat;
    }
  }
}
.split {
  height: 0.3rem;
  border-radius: 0.13rem 0.13rem 0 0;
  background: #f5f5f7;
  transform: translateY(-0.08rem);
}
</style>

